import React, { useState, useEffect } from 'react';
import { avisar } from '../../components/aviso';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from '../../components/SidebarNova.jsx';
import MeuPerfilModal from '../../components/MeuPerfilModal.jsx';
import CapaSalaModal, { urlDaCapa } from '../../components/CapaSalaModal.jsx';
import Dock from '../../components/Dock.jsx';
import SalaIcon from '../../components/SalaIcon.jsx';
import Notificacoes, { ICONE_ORIGEM } from '../../components/Notificacoes.jsx';
import { inscreverNotificacoesPush } from '../../utils/pushNotificacoes';
import SelectPesquisavel from '../../components/SelectPesquisavel.jsx';
import FotoProduto from '../../components/FotoProduto.jsx';
import PodioRanking from '../../components/PodioRanking.jsx';
import PainelPendencias from '../../components/PainelPendencias.jsx';

/**
 * Dashboard — shell principal do sistema.
 *
 * Funciona em dois modos:
 *  - Sem prop `sala`: mostra a grade de salas por categoria (rota /dashboard)
 *  - Com prop `sala`: mostra a sidebar + o conteúdo daquela sala (rota /sala/:n)
 *
 * Antes, a prop `sala` enviada pelo App.jsx não era usada — esta correção
 * faz a navegação para qualquer sala efetivamente funcionar.
 */
export default function Dashboard({ sala }) {
  const { usuario, fotoUrl, logout, isMaster, acessos, pode, alterarTema, tema, navEstilo, alterarNavEstilo, API, podeAcessarSGQ, podeAcessarRH, podeAcessarGeral, acessosExtrasProntos , escalaLeitura, setEscalaLeitura} = useAuth();
  const numPortas = [podeAcessarSGQ, podeAcessarRH, podeAcessarGeral].filter(Boolean).length;
  const mostrarTrocarPortal = acessosExtrasProntos && numPortas > 1;
  // Admin virou 100% Master (31/07/2026, decisão do Juan) — ser ADM de
  // Grupo de Acesso não dá mais acesso ao painel Admin. Quem administra
  // um grupo passa a acessar a Sala 41 (Gestão de Equipe), que agora
  // precisa de liberação própria — não é mais automático só por ser
  // ADM. pode(41) já cobre Master (bypass) + quem tiver a liberação.
  const temAcessoGestaoEquipe = pode(41);
  /* ── "Suas salas" e a capa (06/09/2026, demo aprovada) ─────────────
     ⚠ QUEM PODE EDITAR CAPA É A SALA 0, NÃO O MASTER, e trocar isso
     cria um bug silencioso. `seed` e `ordem` em
     `routes/dashboardConfig.js` exigem `exigirAcesso(0)`, nunca
     `is_master`. Se a capa passar a exigir master, quem receber a Sala 0
     sem ser master vai conseguir mudar a ordem das salas e não a capa,
     sem nenhuma mensagem que explique por quê. Master é uma PESSOA,
     Sala 0 é um PAPEL.

     ⚠ MODO DE EDIÇÃO, E NÃO UM LÁPIS POR CARTÃO. Um lápis por cartão
     são N lápis — o mesmo problema das 22 cápsulas marinho da sidebar,
     onde a peça que aparece em todo lugar para de dizer "aqui". E um
     botão escrito "Editar capas" se ensina sozinho a quem troca capa
     uma vez a cada seis meses; um afordance que só aparece no hover não
     ensina nada, e no celular não existe. */
  const podeEditarCapa = pode(0);
  /* ⚠ A capa vem por BLOB AUTENTICADO, não por URL num <img>. A rota
     exige `autenticar` e uma tag de imagem não manda o cabeçalho
     Authorization — levaria 401 em silêncio e o cartão apareceria
     quebrado. É o mesmo caminho que a foto de perfil já usa, com cache
     de módulo para os cartões não baixarem a mesma capa duas vezes. */
  const [capasUrl, setCapasUrl] = useState({});
  const [editandoCapas, setEditandoCapas] = useState(false);
  const [capaEmEdicao, setCapaEmEdicao] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [salas, setSalas] = useState([]);
  const [produtosDestaque, setProdutosDestaque] = useState([]);
  const [diasSemAcidente, setDiasSemAcidente] = useState([]);
  const [fotosEquipes, setFotosEquipes] = useState([]);
  const [ranking5S, setRanking5S] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [menuAcoesAberto, setMenuAcoesAberto] = useState(false);
  useEffect(() => { setMenuAcoesAberto(false); }, [location.pathname]);

  /* (20/10/2026) A TRAVA ANTIGA DO FUNDO (25/07/2026) SAIU: ela era a segunda trava, por cima da trava única das camadas (utils/camadas.js,
     que já cobre o .modal-overlay e todas as outras), e a cada mudança na tela apagava o overflow do body — com o ⋯ aberto no computador, a
     página voltava ao topo e o alto e as abas sumiam para cima (ele: "quando clico nos três pontos, tá subindo a top bar"). */

  const [modalPerfilAberto, setModalPerfilAberto] = useState(false);
  /* Estado do push deste usuário. Só a home pergunta — é onde a faixa
     vive, e perguntar em toda tela seria uma consulta por navegação. */
  const [pushEstado, setPushEstado] = useState(null);
  const [ativando, setAtivando] = useState(false);
  const [negouAntes, setNegouAntes] = useState(
    typeof Notification !== 'undefined' && Notification.permission === 'denied');
  const [adiado, setAdiado] = useState(() => {
    const quando = Number(localStorage.getItem('sgq_push_adiado') || 0);
    return quando > 0 && Date.now() - quando < 7 * 24 * 60 * 60 * 1000;
  });

  const [pendencias, setPendencias] = useState({ minhas: [], equipe: [], gestaoSala: [], compromissosSemana: [] });
  const [painelAberto, setPainelAberto] = useState(false);
  const [maisOpcoesAberto, setMaisOpcoesAberto] = useState(false);

  useEffect(() => {
    if (!maisOpcoesAberto) return;
    const fechar = (e) => { if (!e.target.closest('.balao-wrap-topbar')) setMaisOpcoesAberto(false); };
    document.addEventListener('click', fechar);
    return () => document.removeEventListener('click', fechar);
  }, [maisOpcoesAberto]);
  const [configVeioDoPadrao, setConfigVeioDoPadrao] = useState(false);

  // Uma tentativa automática se a primeira falhar — cobre o caso de
  // um hiccup passageiro logo na entrada (rede, backend ainda de pé),
  // sem depender da pessoa perceber a tela vazia e dar F5 ela mesma.
  const carregarConfig = (retry = true) => {
    API.get('/dashboard-config')
      .then(r => {
        const s = r.data.salas || [];
        setSalas(s);
        setConfigVeioDoPadrao(!!r.data.from_default || !!r.data.salas_faltando);
      })
      .catch(err => {
        console.error('[Dashboard] Erro ao carregar dashboard-config:', err);
        if (retry) setTimeout(() => carregarConfig(false), 1000);
      });
  };

  useEffect(() => {
    API.get('/notificacoes/push/meu-estado')
      .then(r => setPushEstado(r.data))
      .catch(() => setPushEstado(null));
  }, [API]);

  const carregarResumoAlertas = (retry = true) => {
    API.get('/notificacoes')
      .then(r => setPendencias({ minhas: r.data.minhas || [], equipe: r.data.equipe || [], gestaoSala: r.data.gestaoSala || [], compromissosSemana: r.data.compromissosSemana || [] }))
      .catch(err => {
        console.error('[Dashboard] Erro ao carregar notificações:', err);
        if (retry) setTimeout(() => carregarResumoAlertas(false), 1000);
      });
  };

  useEffect(() => { carregarConfig(); carregarResumoAlertas(); }, []);
  /* ⚠ (V1876, ele: "a sala 1 tá demorando pra carregar") SÓ NA PÁGINA INICIAL: estas quatro são da grade da página
     inicial (os destaques, os dias sem acidente, as fotos das equipes, o ranking do 5S) — e saíam em TODA sala, junto com
     os dados dela. No celular, medido: 13 pedidos da casca disputando a rede antes dos 3 da Sala 1. Agora só quando a
     página inicial aparece (e de novo se a pessoa voltar a ela). */
  useEffect(() => {
    if (sala) return;
    // Produtos em Destaque (30/07/2026) — deliberadamente sem checar
    // acesso à Sala 1/37: decisão do Juan foi que esse resumo (produto
    // + foto + volume, nada de detalhe/histórico) pode aparecer pra
    // qualquer usuário autenticado na Home.
    API.get('/dashboard-config/produtos-destaque').then(r => setProdutosDestaque(r.data.produtos || [])).catch(e => console.error('[carga]', e.message));
    // Dias Sem Acidente pra Home (30/07/2026) — mesma decisão: aparece
    // pra qualquer usuário autenticado, mesmo sem acesso à Sala 24.
    API.get('/dashboard-config/dias-sem-acidente').then(r => setDiasSemAcidente(r.data.empresas || [])).catch(e => console.error('[carga]', e.message));
    // Fotos das Equipes pra Home (04/08/2026, pedido do Juan) — mesma
    // decisão: aparece pra qualquer usuário autenticado. Cada Grupo de
    // Acesso cadastra a própria foto na Sala 41 (Gestão de Equipe).
    API.get('/dashboard-config/fotos-equipes').then(r => setFotosEquipes(r.data.equipes || [])).catch(e => console.error('[carga]', e.message));
    // Ranking de Melhoria pra Home (04/08/2026) — mesma decisão: aparece
    // pra qualquer usuário autenticado. Top 3 por setor, últimos 3
    // meses; detalhe/histórico continua só dentro da Sala 34/8.
    API.get('/dashboard-config/ranking-5s').then(r => setRanking5S(r.data.ranking || [])).catch(e => console.error('[carga]', e.message));
  }, [!!sala]);

  // Dispara a semeadura quando os dois ficarem prontos — "isMaster"
  // vem de uma chamada separada e assíncrona (/acessos/meus), sem
  // ordem garantida com a config do dashboard. Antes isso vivia
  // dentro de carregarConfig(), fechando sobre o isMaster do
  // primeiro render (quase sempre false, antes do /acessos/meus
  // responder) — a semeadura nunca disparava de verdade, e uma sala
  // nova no código (ex.: a 31, a 32) nunca aparecia pra quem já
  // tinha uma configuração salva sem ela.
  useEffect(() => {
    if (configVeioDoPadrao && isMaster) {
      API.post('/dashboard-config/seed', {}).catch(e => console.error('[carga]', e.message));
    }
  }, [configVeioDoPadrao, isMaster]);

  const saudacao = () => {
    const h = new Date().getHours();
    if (h < 12) return 'Bom dia';
    if (h < 18) return 'Boa tarde';
    return 'Boa noite';
  };

  const dataPorExtenso = () => {
    const d = new Date();
    const txt = d.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    return txt.charAt(0).toUpperCase() + txt.slice(1);
  };

  const entrar = (num) => navigate(`/sala/${num}`);

  const podeVer = (num) => pode(num, 'ver');

  // Agrupa salas por categoria (apenas as visíveis ao usuário)
  const categorias = salas.reduce((acc, s) => {
    if (!podeVer(s.sala_numero)) return acc;
    const cat = s.categoria || 'Outros';
    if (!acc[cat]) acc[cat] = { ordem: s.ordem, salas: [] };
    acc[cat].salas.push(s);
    return acc;
  }, {});

  /* ⚠ O MODO "ORGANIZAR SALAS" SAIU INTEIRO (28/08/2026). Eram cinco
     funções, dois estados e três derivados, além do render — tudo para um
     recurso que só o Master via e que ele nunca usou. A ordem das salas
     continua editável direto no banco.

     Tirar só o botão deixaria isto vivo e inalcançável, que é como a aba
     de modelos da Sala 42 apodreceu até quebrar. */
  /* A mesma lista que alimenta as categorias, plana e na ordem que o
     sistema já deriva — a seção "Suas salas" não inventa ordenação
     própria. */
  /* Carrega só as capas que existem, e uma vez por sala. */
  useEffect(() => {
    let vivo = true;
    salas.filter(s => s.capa).forEach(s => {
      urlDaCapa(API, s.sala_numero, s.capa).then(u => {
        if (vivo && u) setCapasUrl(m => (m[s.sala_numero] === u ? m : { ...m, [s.sala_numero]: u }));
      });
    });
    return () => { vivo = false; };
  }, [salas]);

  const salasComCapa = salas
    .filter(s => podeVer(s.sala_numero))
    .sort((a, b) => a.ordem - b.ordem);

  const categoriasOrdenadas = Object.entries(categorias)
    .sort((a, b) => Math.min(...a[1].salas.map(s => s.ordem)) - Math.min(...b[1].salas.map(s => s.ordem)))
    .map(([nome, v]) => ({ nome, salas: v.salas.sort((a, b) => a.ordem - b.ordem) }));

  // ── Modo de edição (reordenar salas) ───────────────────

  // 27/07/2026 — cabeçalho de cada sala removido (Juan: "deixar só a
  // barra superior"). A busca antiga só cobria rotas /sala/N e deixava
  // a barra em branco em /admin (bug que nunca aparecia porque o <h1>
  // de cada sala escondia o problema). Agora resolve o número da URL
  // direto, cobre /admin explicitamente, e usa nome_completo (por
  // extenso) com fallback pro nome abreviado do menu, caso uma sala
  // nova ainda não tenha nome_completo cadastrado.
  const numeroSalaAtual = location.pathname.match(/^\/sala\/(\d+)$/)?.[1];
  const salaAtualObj = numeroSalaAtual ? salas.find(s => String(s.sala_numero) === numeroSalaAtual) : null;
  const tituloAtual = location.pathname === '/admin'
    ? 'Administração'
    : salaAtualObj
    ? (salaAtualObj.nome_completo || salaAtualObj.nome)
    : 'Home';   // (V1885, ele: "pode pôr home lá também, porque não é um dashboard") o mesmo nome do menu — e o da Administração Geral

  const totalMinhas = pendencias.minhas.length;
  const atencaoMinhas = pendencias.minhas.filter(p => p.urgencia === 'atencao').length;
  const itensEquipe = pendencias.equipe.flatMap(p => p.itens);
  const totalEquipe = itensEquipe.length;
  const criticosEquipe = itensEquipe.filter(p => p.urgencia === 'critico').length;
  const totalGestaoSala = pendencias.gestaoSala.length;
  const criticosGestaoSala = pendencias.gestaoSala.filter(p => p.urgencia === 'critico').length;
  const atencaoGestaoSala = pendencias.gestaoSala.filter(p => p.urgencia === 'atencao').length;
  const compromissosSemanaPendentes = pendencias.compromissosSemana;
  const proximoCompromisso = compromissosSemanaPendentes[0];

  return (
    <div className={`shell ${navEstilo === 'dock' ? 'nav-dock' : ''}`}>
      {navEstilo === 'dock' ? (
        <Dock usuario={usuario} categorias={categoriasOrdenadas} />
      ) : (
        <Sidebar
          usuario={usuario}
          categorias={categoriasOrdenadas}
          open={sidebarAberta}
          onClose={() => setSidebarAberta(false)}
        />
      )}

      <div className="main">
        <div className="app-topbar">
          {navEstilo !== 'dock' && (
            <button className="m-menu-btn" onClick={() => setSidebarAberta(true)} aria-label="Abrir menu">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round">
                <line x1="5" y1="7" x2="19" y2="7" /><line x1="5" y1="12" x2="19" y2="12" /><line x1="5" y1="17" x2="19" y2="17" />
              </svg>
            </button>
          )}
          {/* Logo saiu da sidebar (rodada de exploração visual, 29/07/2026)
              — vive aqui agora, sem faixa própria dedicada, reaproveitando
              a altura que o topbar já tinha. Só aparece fora do modo Dock,
              que já tem a própria cápsula de logo. */}
          {navEstilo !== 'dock' && (
            <div className="app-topbar-brand">
              <span className="marca-portal">SGQ <strong>GESTÃO</strong></span>
            </div>
          )}
          <div className="app-topbar-titulo-wrap">
            {numeroSalaAtual && <span className="app-topbar-badge">Sala {numeroSalaAtual}</span>}
            <span className="app-topbar-title">{tituloAtual}</span>
          </div>

          {/* ⚠ SLOT DO MANUAL DA SALA (21/08/2026, pedido do Juan) — o
              botão é renderizado AQUI, mas quem o cria é a sala: ela guarda
              o estado do modal e decide o título. Ver `BotaoManual.jsx`.

              Portal em vez de subir o estado: seriam 47 salas informando o
              próprio manual a três layouts diferentes. Assim cada sala troca
              uma linha, e nenhum layout precisa saber que manuais existem. */}

          <button className="m-acoes-btn" onClick={() => setMenuAcoesAberto(v => !v)} aria-label="Mais ações">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="5" r="1.6" /><circle cx="12" cy="12" r="1.6" /><circle cx="12" cy="19" r="1.6" />
            </svg>
          </button>

          <div className={`app-topbar-r ${menuAcoesAberto ? 'aberto' : ''}`}>
            {/* O manual mudou de lugar em 24/08/2026 (pedido do Juan): estava
                solto ao lado do título, numa caixa com fundo e borda, entre
                ícones que não têm nenhum dos dois. Virou o primeiro do grupo da
                direita, com o mesmo tratamento do sino e dos outros. */}
            <div id="slot-manual-topbar" className="slot-manual-topbar" />
            <Notificacoes />
            <div style={{ position: 'relative' }} className="balao-wrap-topbar">
              <button className="btn-acao" onClick={() => setMaisOpcoesAberto(v => !v)} title="Mais opções">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" style={{ transform: maisOpcoesAberto ? 'rotate(180deg)' : 'none', transition: 'transform .15s' }}><polyline points="6,9 12,15 18,9" /></svg>
              </button>
              <div className={`balao-topbar${maisOpcoesAberto ? ' aberto' : ''}`}>
                {/* ── OS AJUSTES MORAM NO BALÃO, EM QUALQUER LARGURA ─────────
                    (25/08/2026, print do Juan: "ocupa muito espaço na upbar")

                    Navegação, leitura e tema são preferências tocadas uma vez
                    por mês. Na barra do telefone disputavam com o nome da
                    sala, que aparecia como "C…" — e no computador eram três
                    ícones sem rótulo, um deles um `A` que não dizia em que
                    nível a leitura estava.

                    Aqui têm NOME e ESTADO escritos. Uma regra só nas duas
                    larguras: comportamento diferente por tamanho de tela é
                    dívida de manutenção quando não há razão para diferir, e
                    aqui não há — o balão cabe nos dois. */}
                <div className="balao-item-topbar"
                  onClick={() => { alterarNavEstilo(navEstilo === 'dock' ? 'sidebar' : 'dock'); setMaisOpcoesAberto(false); }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="16" rx="2" /><path d="M9 4v16" />
                  </svg> {navEstilo === 'dock' ? 'Menu lateral' : 'Barra embaixo'}
                </div>
                <div className="balao-item-topbar"
                  onClick={() => setEscalaLeitura(
                    escalaLeitura === 'normal' ? 'medio' : escalaLeitura === 'medio' ? 'ampliado' : 'normal')}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 19l6.5-15 6.5 15M7 14h7" />
                    {escalaLeitura !== 'normal' && <path d="M19 10v6M16 13h6" />}
                  </svg> Leitura {escalaLeitura === 'normal' ? 'normal' : escalaLeitura === 'medio' ? 'média' : 'ampliada'}
                </div>
                <div className="balao-item-topbar"
                  onClick={() => { alterarTema(tema === 'light' ? 'dark' : 'light'); setMaisOpcoesAberto(false); }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="4.5" />
                    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
                  </svg> {tema === 'light' ? 'Tema escuro' : 'Tema claro'}
                </div>
                {isMaster && (
                  <div className="balao-item-topbar" onClick={() => { navigate('/admin'); setMaisOpcoesAberto(false); }}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="6.5" /><circle cx="12" cy="12" r="2.7" />
                      <rect x="10.8" y="2.9" width="2.4" height="2.4" rx="0.5" /><rect x="10.8" y="2.9" width="2.4" height="2.4" rx="0.5" transform="rotate(60 12 12)" /><rect x="10.8" y="2.9" width="2.4" height="2.4" rx="0.5" transform="rotate(120 12 12)" /><rect x="10.8" y="2.9" width="2.4" height="2.4" rx="0.5" transform="rotate(180 12 12)" /><rect x="10.8" y="2.9" width="2.4" height="2.4" rx="0.5" transform="rotate(240 12 12)" /><rect x="10.8" y="2.9" width="2.4" height="2.4" rx="0.5" transform="rotate(300 12 12)" />
                    </svg> Admin
                  </div>
                )}
                {/* a limpa (V1908, core/557): com a Sala 41 oculta, o atalho dela sai junto — e volta sozinho quando ela voltar */}
                {!isMaster && temAcessoGestaoEquipe && salas.some(x => x.sala_numero === 41) && (
                  <div className="balao-item-topbar" onClick={() => { navigate('/sala/41'); setMaisOpcoesAberto(false); }}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"><circle cx="8.25" cy="7.5" r="3.75"/><circle cx="15.75" cy="7.5" r="3.75"/><path d="M1.5 21c0-3.75 3-6 6.75-6s6.75 2.25 6.75 6"/><path d="M15.75 15c3.75 0 6.75 2.25 6.75 6"/></svg> Gestão de Equipe
                  </div>
                )}
                {mostrarTrocarPortal && (
                  <div className="balao-item-topbar" onClick={() => { navigate('/portal'); setMaisOpcoesAberto(false); }}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/></svg> Trocar de Portal
                  </div>
                )}
                <div className="balao-item-topbar sair" onClick={logout}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M9 3H5a1.5 1.5 0 00-1.5 1.5v15A1.5 1.5 0 005 21h4" /><path d="M15.5 16l4.5-4-4.5-4" /><line x1="20" y1="12" x2="9" y2="12" /></svg> Sair
                </div>
              </div>
            </div>
            {navEstilo === 'dock' && (
              <div className="user-chip" style={{ cursor: 'pointer' }} title="Meu perfil" onClick={() => setModalPerfilAberto(true)}>
                <span className="avatar">
                  {fotoUrl ? <img src={fotoUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} /> : (usuario?.nome || '?').trim().split(' ').slice(0, 2).map(p => p[0]).join('').toUpperCase()}
                </span>
                <span className="nome-user">{usuario?.nome?.split(' ')[0] || 'Usuário'}</span>
              </div>
            )}
          </div>
        </div>

        <MeuPerfilModal aberto={modalPerfilAberto} onClose={() => setModalPerfilAberto(false)} />

        {/* O modal de capa monta só quando há sala escolhida — não fica
            um componente oculto lendo estado a cada render da Home. E o
            `onSalvo` atualiza a lista em memória em vez de recarregar
            tudo: a capa que a pessoa acabou de enquadrar aparece no
            cartão na hora, sem uma segunda chamada. */}
        {capaEmEdicao && (
          <CapaSalaModal
            sala={capaEmEdicao}
            API={API}
            onFechar={() => setCapaEmEdicao(null)}
            onSalvo={(nova) => setSalas(lista => lista.map(
              s => s.sala_numero === nova.sala_numero ? { ...s, ...nova } : s
            ))}
          />
        )}

        {/* (V1910) a sala v2 vai de borda a borda da barra de topo (ele: "deixar alinhado as laterais com as laterais da upbar"): a classe
            diz isso direto, sem depender do :has() — no celular dele o :has() não pegou no Diário de Bordo e o conteúdo ficou 15 px para
            dentro de cada lado. As salas v2: a 5 (AT & All Care) e a 19 (o Diário de Bordo). */}
        <div className={`app-page${['5', '19'].includes(numeroSalaAtual) ? ' app-page-v2' : ''}`}>
          {/* key={location.pathname} força o React a remontar este bloco a
              cada troca de rota/sala — é isso que dispara a animação
              .fade-transicao de novo em cada navegação (senão ela só
              rodaria uma vez, no primeiro carregamento). Fade simples e
              rápido, sem interferir na performance (15/07/2026). */}
          <div key={location.pathname} className="fade-transicao">
          {sala ? (
            sala
          ) : (
            <>
              <div className="greeting-line">
                <span className="greeting-name">{saudacao()}, {usuario?.nome?.split(' ')[0]}.</span>
                <span className="greeting-date">{dataPorExtenso()}</span>
              </div>

              {/* ⚠ A FAIXA DO PUSH DESLIGADO (28/08/2026, demo aprovada,
                  opção A).

                  Aparece só para quem tem papel que gera push e não tem
                  aparelho inscrito — o servidor decide em `precisa_ativar`,
                  para não existirem duas versões da mesma regra.

                  Fica ACIMA de "o que precisa de você" de propósito: a
                  lista logo abaixo é a prova do argumento — é exatamente o
                  que a pessoa fica sabendo só ao abrir o sistema. */}
              {pushEstado?.precisa_ativar && !adiado && (
                <div className="push-faixa">
                  <span className="push-faixa-ic" aria-hidden="true">
                    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18.5 9.5a6.5 6.5 0 10-13 0c0 4.2-1.2 6-2 6.9a.8.8 0 00.6 1.3h15.8a.8.8 0 00.6-1.3c-.8-.9-2-2.7-2-6.9z" />
                      <path d="M14 20.5a2.2 2.2 0 01-4 0" /><path d="M3 3l18 18" />
                    </svg>
                  </span>
                  <span className="push-faixa-t">
                    <b>Você não recebe aviso neste aparelho</b>
                    <p>
                      Você {pushEstado.papeis.join(' e ')}. Sem a notificação ligada, só fica
                      sabendo quando abre o sistema — e uma peça pode esperar o dia inteiro.
                    </p>
                    {/* ⚠ O NAVEGADOR SÓ PERGUNTA UMA VEZ POR APARELHO. Se a
                        pessoa já negou, o prompt não volta e o botão não
                        resolveria nada — então o texto muda e ensina o
                        caminho, em vez de prometer o que não pode. */}
                    {negouAntes ? (
                      <p style={{ marginTop: 6 }}>
                        As notificações foram bloqueadas neste aparelho. Para reverter, abra os
                        ajustes do navegador, procure este site e permita notificações.
                      </p>
                    ) : (
                      <span className="push-faixa-bt">
                        <button type="button" className="acao acao-m acao-principal"
                          disabled={ativando}
                          onClick={async () => {
                            setAtivando(true);
                            try {
                              await inscreverNotificacoesPush(API);
                              const r = await API.get('/notificacoes/push/meu-estado');
                              setPushEstado(r.data);
                              if (r.data.aparelhos === 0) setNegouAntes(true);
                            } finally { setAtivando(false); }
                          }}>
                          {ativando ? 'Ativando…' : 'Ativar notificações'}
                        </button>
                        <button type="button" className="acao acao-m acao-quieta"
                          onClick={() => {
                            /* Some por 7 dias, não para sempre: a pessoa pode
                               estar no meio de outra coisa. */
                            localStorage.setItem('sgq_push_adiado', String(Date.now()));
                            setAdiado(true);
                          }}>
                          Agora não
                        </button>
                      </span>
                    )}
                  </span>
                </div>
              )}

              {/* ⚠ O CARD "MINHAS DEMANDAS" SAIU (28/08/2026, Juan: "ele
                  perdeu o objetivo, pois em 90% do tempo aparece com 0").

                  Ele e a seção abaixo liam a MESMA fonte — `pendencias.minhas`.
                  O card mostrava a contagem, a seção mostra os itens: duas
                  leituras do mesmo dado, e a que fica em zero era a que
                  ocupava o alto da tela, em corpo 30, todo dia, inclusive
                  para quem nunca vai ter uma atribuição no sistema.

                  A contagem passou para o rótulo da seção, onde informa sem
                  ocupar o lugar nobre. E a seção já sumia sozinha quando
                  vazia — então quem não tem demanda não vê mais o assunto,
                  e o sino continua ali para quando tiver. */}

              {/* Home unificada (04/08/2026, aprovado com o Juan) — toda
                  seção segue a mesma regra agora: rótulo (.home-rotulo)
                  sempre fora/acima do conteúdo, mesmo espaçamento
                  (.home-secao). "O que precisa de você" (30/07/2026,
                  pedido do Juan) — antes só aparecia dentro do painel
                  que abre ao clicar no KPI; agora fica sempre visível
                  na própria Home. Mesmo dado (pendencias.minhas, de
                  /notificacoes), mesma navegação (`/sala/${item.sala}`)
                  já usada no painel. */}
              {pendencias.minhas.length > 0 && (
                <div className="home-secao">
                  <div className="home-rotulo">
                    O que precisa de você · {pendencias.minhas.length}
                  </div>
                  <div className="card">
                    {pendencias.minhas.map((item, i) => (
                      /* ⚠ A MESMA LINHA DO SINO (28/08/2026). Era um desenho
                         próprio, com o ponto de 8px e cor de estado em `style`
                         inline — o defeito que o portão 32 persegue.

                         Agora usa `.n-row`, que já traz a faixa de urgência na
                         borda e o ícone da origem. Uma informação, dois
                         lugares, um desenho só. */
                      <div key={i} className={`n-row ${item.urgencia === 'critico' ? 'crit' : 'aten'}`}
                        role="button" tabIndex={0}
                        onClick={() => item.sala && navigate(`/sala/${item.sala}`)}
                        onKeyDown={(e) => { if (e.key === 'Enter' && item.sala) navigate(`/sala/${item.sala}`); }}>
                        <span className="n-ic" aria-hidden="true">{ICONE_ORIGEM(item.sala)}</span>
                        <div className="n-txt">
                          <strong>{item.titulo}</strong>
                          {item.descricao && <div className="n-time">{item.descricao}</div>}
                        </div>
                        <span className="n-seta" aria-hidden="true">
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M9 6l6 6-6 6" />
                          </svg>
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {produtosDestaque.length > 0 && (
                <div className="home-secao">
                  {/* ⚠ A JANELA ESTAVA MUDA (15/09/2026). A consulta olha 30 DIAS, e o
                      cartão dizia só "1º mais expedido" — quem lê entende "de
                      sempre", e um produto que saiu muito no mês passado e parou
                      apareceria como líder histórico.
                      ⚠ Indicador que esconde o próprio recorte não está errado
                      na conta, está errado na frase. */}
                  <div className="home-rotulo">Produtos em Destaque · últimos 30 dias</div>
                  <div className="home-carrossel">
                    {produtosDestaque.map((p, i) => (
                      <div key={i} className="home-carrossel-item" style={{ width:80 }}>
                        {/* ⚠ O TESTE ERA `p.foto && p.produto_id` (corrigido 03/09/2026).
                            `p.foto` guarda o CAMINHO do arquivo, não uma URL — e o
                            `<FotoProduto>` busca pela rota autenticada usando só o
                            `produto_id`. A tela olhava um dado que não usa, para decidir
                            sobre um componente que se vira sozinho.

                            Quebrou quando a consulta foi reescrita para `SUM(quantidade)`
                            e o `p.foto` saiu do SELECT por não ser usado em lugar nenhum
                            visível: o teste passou a dar falso sempre e os cinco caíram
                            no quadrado vazio. A Sala 37 não quebrou porque chama o
                            `<FotoProduto>` direto, sem testar nada — e é ela que está
                            certa. Resíduo do mesmo defeito de 19/08, quando o caminho
                            era tratado como URL. */}
                        {p.produto_id ? (
                          <div style={{ marginBottom:8 }}><FotoProduto produtoId={p.produto_id} /></div>
                        ) : (
                          <div className="home-miniatura" style={{ width:64, height:64 }} />
                        )}
                        <div className="home-carrossel-nome">{p.produto}</div>
                        {/* ⚠ ERA "↑ mais expedida" NOS CINCO (03/09/2026). O quinto
                            colocado não é "o mais expedido" — é o quinto, e dizer o
                            contrário em todos apagava a única informação que o
                            carrossel carrega: a ordem. */}
                        <div style={{ fontSize: 'var(--txt-11)', color:'var(--sem-success-text)', fontWeight:700, marginTop:2 }}>{i + 1}º mais expedido</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Dias Sem Acidente — ocultado da Home a pedido do Juan
                  (10/08/2026), "por hora": ou seja, removido de forma
                  reversível, não apagado. O estado `diasSemAcidente` e
                  o carregamento continuam intactos (ver useState acima
                  e o fetch correspondente) — só a renderização deste
                  bloco foi comentada. Pra trazer de volta, é só
                  remover o comentário abaixo, sem precisar reconstruir
                  nada. Card ainda existe/funciona normalmente nas
                  salas próprias (Sala 24, 28, 31) — só a Home foi
                  afetada por este pedido. */}
              {false && diasSemAcidente.length > 0 && (
                <div className="home-secao">
                  <div className="home-rotulo">Dias Sem Acidente</div>
                  <div className="card home-colunas dsa-card" style={{ gridTemplateColumns: `repeat(${diasSemAcidente.length}, 1fr)` }}>
                    {diasSemAcidente.map(e => (
                      <div key={e.empresa_id} className="home-col-item dsa-item">
                        <div className="dsa-item-inner">
                          <div style={{ fontSize:'var(--txt-24)', fontWeight: 700, letterSpacing:'-.5px', color: e.eh_recorde_atual ? 'var(--ext)' : 'var(--sem-success-text)' }}>{e.dias}</div>
                          <div style={{ fontSize: 'var(--txt-11)', fontWeight:700, textTransform:'uppercase', letterSpacing:'.4px', color:'var(--text-secondary)', marginTop:4 }}>{e.prefixo}</div>
                          <div style={{ fontSize:'var(--txt-11)', fontWeight: 500, color:'var(--text-secondary)', marginTop:6 }}>
                            {e.eh_recorde_atual ? 'é o recorde!' : <>recorde: <strong style={{ color:'var(--text-primary)' }}>{e.recorde_dias}</strong></>}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Fotos das Equipes (04/08/2026, pedido do Juan) — cada
                  Grupo de Acesso cadastra a própria foto na Sala 41
                  (Gestão de Equipe); aqui aparecem todas juntas, num
                  carrossel horizontal — mesmo componente visual de
                  Produtos em Destaque (.home-carrossel), só cartão
                  maior (é gente, não ícone de produto).

                  Ocultado da Home a pedido do Juan (10/08/2026),
                  "por hora" — mesmo padrão reversível do card Dias
                  Sem Acidente (ver seção própria em
                  DIRETRIZES_VISUAIS_SGQ.md): `false &&` na frente,
                  nada apagado. `useState`/carregamento intactos, e o
                  cadastro da foto em si na Sala 41 continua
                  funcionando normalmente — só a Home parou de
                  mostrar. Pra reverter: remover o `false &&`. */}
              {false && fotosEquipes.length > 0 && (
                <div className="home-secao">
                  <div className="home-rotulo">Nossas Equipes</div>
                  <div className="home-carrossel">
                    {fotosEquipes.map(e => (
                      <div key={e.grupo_id} className="home-carrossel-item" style={{ width:120 }}>
                        <img src={e.foto} alt="" className="home-miniatura" style={{ width:120, height:120, borderRadius: 'var(--r-lg)' }} />
                        <div className="home-carrossel-nome" style={{ fontSize:'var(--txt-13)', fontWeight: 500 }}>{e.nome}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Ranking de Melhoria (04/08/2026, pedido do Juan — "pensa
                  comigo", aprovado depois de comparar 2 propostas de
                  layout). Top 3 por setor (o da Melhoria Contínua saiu com a Sala 34 antiga)
                  e 5S (Sala 8), últimos 3 meses — resto do dado
                  (histórico, detalhe por categoria) continua só dentro
                  de cada sala, por decisão do Juan. Duas colunas
                  (.home-colunas) com o mesmo motivo visual de "Dias Sem
                  Acidente", mais o brilho sutil (.card-brilho) que é o
                  único destaque do tipo em toda a Home. */}
              {/* (26/09/2026) o pódio da Melhoria Contínua saiu com a Sala 34 antiga — fica o do 5S */}
              {/* o pódio do 5S só com a Sala 8 no menu (a limpa, V1908 — core/557) */}
              {ranking5S.length > 0 && salas.some(x => x.sala_numero === 8) && (
                <div className="home-secao">
                  <div className="home-rotulo">Ranking de Melhoria</div>
                  <div className="card home-colunas card-brilho home-ranking">
                    <div className="home-col-item" style={{ padding:'0 4px' }}>
                      <PodioRanking titulo="5S" periodo="Últimos 3 meses" dados={ranking5S.map(r => ({ ...r, valor: r.percentual }))} sufixo="%" />
                    </div>
                  </div>
                </div>
              )}


              {/* ⚠ "ORGANIZAR SALAS" SAIU (28/08/2026, Juan: "quero remover da
                  tela, de qualquer forma eu só faço isso direto pelo código").

                  Era um modo de edição inteiro: reordenar por setas, mover
                  entre categorias, salvar. Visível só para o Master — e o
                  Master é ele, que nunca usou.

                  ⚠ REMOVIDO INTEIRO, E NÃO SÓ O BOTÃO. O modo de edição
                  entrelaçava o render das salas em oito pontos. Tirar apenas
                  o gatilho deixaria tudo isso vivo e inalcançável — que é a
                  definição de código morto, e foi assim que a aba de modelos
                  da Sala 42 apodreceu até quebrar. */}
              {/* ⚠ "SUAS SALAS" DESCEU PARA DEPOIS DOS PAINÉIS (07/09/2026).
                  Ela estava em primeiro, e empurrava para baixo da dobra tudo
                  o que a Home tem de INFORMAÇÃO — pendências, produtos em
                  destaque, dias sem acidente, equipes, ranking.

                  A Home não é um menu: para navegar já existem a sidebar e o
                  dock, sempre visíveis. O que só existe aqui são os números.
                  Então eles vêm primeiro, e a grade de salas fecha a página. */}
              {/* ══ SUAS SALAS (06/09/2026, demo aprovada) ═════════════════
                  Seção nova. Cada sala liberada ganha um cartão com capa;
                  sem capa, o cartão cai no ícone da sala sobre o nível 3 —
                  o vazio é uma superfície, não um retângulo sem explicação.

                  ⚠ O ENQUADRAMENTO É CSS PURO. O modal produz três valores
                  (`capa`, `capa_pos`, `capa_zoom`) e o cartão só os lê:
                  `background-position` e `transform-origin` recebem o MESMO
                  par, e o `scale` gira em volta dele. Nenhuma linha de JS
                  em produção — o JS existe só enquanto a pessoa arrasta
                  dentro do modal.

                  ⚠ COM O MODO LIGADO, O CARTÃO NÃO NAVEGA. Era o risco real
                  de ligar a edição pela seção: o mesmo clique significando
                  duas coisas. O `.hs-pe` fica inerte por CSS e o `onClick`
                  do cartão sai do caminho. Um clique, um significado. */}
              {salasComCapa.length > 0 && (
                <div className="home-secao">
                  <div className="hs-cab">
                    <div className="home-rotulo">Suas salas</div>
                    {podeEditarCapa && (
                      <button className="hs-editar" aria-pressed={editandoCapas}
                        onClick={() => setEditandoCapas(v => !v)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85"
                          strokeLinecap="round" strokeLinejoin="round" width="13" height="13">
                          <path d="M4 20h4l10-10-4-4L4 16z" /><path d="M13.5 6.5l4 4" />
                        </svg>
                        {editandoCapas ? 'Concluir' : 'Editar capas'}
                      </button>
                    )}
                  </div>

                  {/* ⚠ AGRUPADO POR CATEGORIA, NA ORDEM QUE O SISTEMA JÁ DERIVA.
                      A primeira versão era uma lista plana: os cartões novos
                      substituíram os antigos e levaram junto a organização que
                      eles tinham. Categoria e ordem não são enfeite — são como
                      a pessoa acha a sala, e a sidebar usa exatamente as mesmas.
                      A fonte é o `categoriasOrdenadas`, o mesmo objeto que
                      alimenta a sidebar e o dock: um lugar só decide a ordem. */}
                  {categoriasOrdenadas.map(c => {
                    const visiveis = c.salas
                      .filter(x => podeVer(x.sala_numero))
                      .sort((a, b) => a.ordem - b.ordem);
                    if (!visiveis.length) return null;
                    return (
                      <div className="hs-cat" key={c.nome}>
                        <div className="hs-cat-nome">{c.nome}</div>
                        <div className={`hs-grade${editandoCapas ? ' editando' : ''}`}>
                          {visiveis.map(s => (
                            <div key={s.sala_numero} className="hs-cartao"
                              role={editandoCapas ? undefined : 'button'}
                              tabIndex={editandoCapas ? -1 : 0}
                              onClick={() => { if (!editandoCapas) entrar(s.sala_numero); }}
                              onKeyDown={(e) => { if (e.key === 'Enter' && !editandoCapas) entrar(s.sala_numero); }}>
                              <div className="hs-capa"
                                onClick={(e) => {
                                  if (!editandoCapas) return;
                                  e.stopPropagation();
                                  setCapaEmEdicao(s);
                                }}>
                                {s.capa && capasUrl[s.sala_numero]
                                  ? <i style={{
                                      backgroundImage: `url("${capasUrl[s.sala_numero]}")`,
                                      '--capa-pos': s.capa_pos || '50% 50%',
                                      '--capa-zoom': s.capa_zoom || 1
                                    }} />
                                  : <SalaIcon numero={s.sala_numero} size={26} />}
                              </div>
                              <div className="hs-pe">
                                <div className="hs-nome">{s.nome}</div>
                                <div className="hs-num">Sala {s.sala_numero}</div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}


              {/* ⚠ A GRADE ANTIGA DE SALAS SAIU (07/09/2026). Ela desenhava as
                  MESMAS salas que a seção "Suas salas" já desenha, logo acima —
                  a tela mostrava cada sala duas vezes, com dois desenhos
                  diferentes, desde que os cartões de capa entraram em V1290.

                  Escrever o substituto e não remover o substituído é o defeito
                  que este projeto persegue, e eu o cometi: entreguei os cartões
                  novos sem tirar os velhos, e só apareceu quando alguém abriu a
                  tela. A categoria e a ordem que esta grade usava não se
                  perderam — passaram para "Suas salas", que agora agrupa pelo
                  mesmo `categoriasOrdenadas`. */}
              {salas.length === 0 && (
                <div className="sala-grid">
                  {[1,2,3,4].map(i => (
                    <div key={i} className="card" style={{ padding:16 }}>
                      <div className="skeleton-linha" style={{ width:24, height:24, borderRadius: 'var(--r-sm)', marginBottom:12 }}></div>
                      <div className="skeleton-linha" style={{ width:'70%' }}></div>
                      <div className="skeleton-linha" style={{ width:'40%' }}></div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
          </div>
        </div>
      </div>

      <PainelPendencias
        aberto={painelAberto}
        dados={pendencias}
        onClose={() => setPainelAberto(false)}
      />
    </div>
  );
}
